/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../cash/crypto/amount';
import '../connect/v2/resources/error';
import './model';
import '../paymentbalances/common';
import './content';
import '../common/currency';
import '../bankc/model';
import './w9';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bitty": {
        "nested": {
          "CreateWithdrawalRequest": {
            "fields": {
              "idempotencyKey": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "destinationAddress": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "amount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 3,
                "rule": "optional"
              },
              "note": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "CreateWithdrawalResponse": {
            "fields": {
              "withdrawalId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              },
              "userInteractions": {
                "type": ".squareup.bitty.UserInteraction",
                "id": 3,
                "rule": "repeated"
              },
              "nextEndpoint": {
                "type": ".squareup.bitty.Endpoint",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "CreateBitcoinAccountRequest": {
            "fields": {
              "withholdingBps": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "paymentSettings": {
                "type": ".squareup.bitty.PaymentSettings",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "CreateBitcoinAccountResponse": {
            "fields": {
              "bitcoinAccount": {
                "type": ".squareup.bitty.BitcoinAccount",
                "id": 1,
                "rule": "optional"
              },
              "error": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "RetrieveBitcoinAccountRequest": {
            "fields": {
              "retrieveWallet": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RetrieveBitcoinAccountResponse": {
            "fields": {
              "bitcoinAccount": {
                "type": ".squareup.bitty.BitcoinAccount",
                "id": 1,
                "rule": "optional"
              },
              "accountEligibility": {
                "type": ".squareup.bitty.BitcoinAccountStatus",
                "id": 2,
                "rule": "optional"
              },
              "error": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 3,
                "rule": "repeated"
              },
              "walletDetails": {
                "type": ".squareup.bitty.WalletDetails",
                "id": 4,
                "rule": "optional"
              },
              "maxWithholdingBps": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              },
              "withholdingBpsIncrement": {
                "type": "int32",
                "id": 6,
                "rule": "optional"
              },
              "minimumAmount": {
                "type": ".squareup.cash.crypto.BitcoinAmount",
                "id": 7,
                "rule": "optional"
              },
              "conversionFeeBps": {
                "type": "int32",
                "id": 8,
                "rule": "optional"
              }
            }
          },
          "UpdateBitcoinAccountRequest": {
            "fields": {
              "bitcoinAccount": {
                "type": ".squareup.bitty.BitcoinAccount",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "UpdateBitcoinAccountResponse": {
            "fields": {
              "bitcoinAccount": {
                "type": ".squareup.bitty.BitcoinAccount",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "EvaluateKybStatusRequest": {
            "fields": {
              "businessType": {
                "type": ".squareup.bitty.BusinessType",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "BUSINESS_TYPE_UNSPECIFIED"
                }
              },
              "uniquenessKey": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "EvaluateKybStatusResponse": {
            "fields": {
              "kybStatusToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "btcKybStatus": {
                "type": ".squareup.bitty.BtcKybStatus",
                "id": 2,
                "rule": "optional"
              },
              "maxWithholdingBps": {
                "type": "uint32",
                "id": 3,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 4,
                "rule": "repeated"
              },
              "kybSessionUrl": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "GetBitcoinActivitiesRequest": {
            "fields": {
              "startTime": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "endTime": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": 10
                }
              },
              "cursor": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "activityType": {
                "type": ".squareup.paymentbalances.ActivityType",
                "id": 5,
                "rule": "optional"
              },
              "fetchDetails": {
                "type": "bool",
                "id": 6,
                "rule": "optional"
              },
              "activityTypes": {
                "type": ".squareup.paymentbalances.ActivityType",
                "id": 7,
                "rule": "repeated"
              }
            }
          },
          "GetBitcoinActivitiesResponse": {
            "fields": {
              "bitcoinActivities": {
                "type": ".squareup.bitty.BitcoinActivity",
                "id": 1,
                "rule": "repeated"
              },
              "cursor": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "GetBitcoinActivityDetailRequest": {
            "fields": {
              "withdrawalId": {
                "type": "string",
                "id": 1
              },
              "exchangeId": {
                "type": "string",
                "id": 2
              },
              "invoiceId": {
                "type": "string",
                "id": 3
              },
              "promotionalRewardId": {
                "type": "string",
                "id": 4
              },
              "bankcProviderMovementProcessingIdentifier": {
                "type": "string",
                "id": 5
              }
            },
            "nested": {
              "activity_id": {
                "oneof": ["withdrawalId", "exchangeId", "invoiceId", "promotionalRewardId", "bankcProviderMovementProcessingIdentifier"]
              }
            }
          },
          "GetBitcoinActivityDetailResponse": {
            "fields": {
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 3,
                "rule": "repeated"
              },
              "exchangeDetail": {
                "type": ".squareup.bitty.ExchangeDetail",
                "id": 1
              },
              "withdrawal": {
                "type": ".squareup.bitty.Withdrawal",
                "id": 2
              },
              "invoice": {
                "type": ".squareup.bitty.Invoice",
                "id": 4
              },
              "promotionalReward": {
                "type": ".squareup.bitty.PromotionalReward",
                "id": 5
              }
            },
            "nested": {
              "bitcoin_detail": {
                "oneof": ["exchangeDetail", "withdrawal", "invoice", "promotionalReward"]
              }
            }
          },
          "CreateWaitlistEntryRequest": {
            "fields": {}
          },
          "CreateWaitlistEntryResponse": {
            "fields": {
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "GetContentRequest": {
            "fields": {
              "contentType": {
                "type": ".squareup.bitty.ContentType",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "GetContentResponse": {
            "fields": {
              "content": {
                "type": ".squareup.bitty.Content",
                "id": 1,
                "rule": "repeated"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "ExecuteWithdrawalRequest": {
            "fields": {
              "withdrawalId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "withdrawalActions": {
                "type": ".squareup.bitty.WithdrawalAction",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "ExecuteWithdrawalResponse": {
            "fields": {
              "withdrawalId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "userInteractions": {
                "type": ".squareup.bitty.UserInteraction",
                "id": 2,
                "rule": "repeated"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 3,
                "rule": "repeated"
              },
              "nextEndpoint": {
                "type": ".squareup.bitty.Endpoint",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "CreateOnDemandKybSessionRequest": {
            "fields": {}
          },
          "CreateOnDemandKybSessionResponse": {
            "fields": {
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 1,
                "rule": "repeated"
              },
              "kybSessionToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "frontendUrl": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "GetExchangeQuoteRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "bitcoinTransactionType": {
                "type": ".squareup.bitty.BitcoinTransactionType",
                "id": 2,
                "rule": "optional"
              },
              "amount": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "exchangeFeature": {
                "type": ".squareup.bitty.ExchangeFeature",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "GetExchangeQuoteResponse": {
            "fields": {
              "quote": {
                "type": ".squareup.bitty.Quote",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "ExecuteManualExchangeRequest": {
            "fields": {
              "quoteToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "exchangeToken": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.bitty.ExchangeDetail.ExchangeType",
                "id": 5,
                "rule": "optional"
              },
              "sourceBalance": {
                "type": ".squareup.bitty.SourceTargetBalance",
                "id": 2
              },
              "targetBalance": {
                "type": ".squareup.bitty.SourceTargetBalance",
                "id": 3
              }
            },
            "nested": {
              "source_target_balance": {
                "oneof": ["sourceBalance", "targetBalance"]
              }
            }
          },
          "ExecuteManualExchangeResponse": {
            "fields": {
              "exchangeToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "GetSourceTargetBalancesRequest": {
            "fields": {}
          },
          "GetSourceTargetBalancesResponse": {
            "fields": {
              "ledgerBalances": {
                "type": ".squareup.bankc.BalanceSummary",
                "id": 1,
                "rule": "repeated"
              },
              "checkingBalances": {
                "type": ".squareup.bankc.BalanceSummary",
                "id": 2,
                "rule": "repeated"
              },
              "savingsBalances": {
                "type": ".squareup.bankc.BalanceSummary",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "CheckBitcoinPaymentsEnabledRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "CheckBitcoinPaymentsEnabledResponse": {
            "fields": {
              "bitcoinPaymentsStatus": {
                "type": ".squareup.bitty.BitcoinPaymentsStatus",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "ListPromotionalRewardsRequest": {
            "fields": {
              "promotionalRewardStates": {
                "type": ".squareup.bitty.PromotionalReward.PromotionalRewardState",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "ListPromotionalRewardsResponse": {
            "fields": {
              "promotionalRewards": {
                "type": ".squareup.bitty.PromotionalReward",
                "id": 1,
                "rule": "repeated"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "GetDepositAddressRequest": {
            "fields": {}
          },
          "GetDepositAddressResponse": {
            "fields": {
              "walletAddress": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "EvaluateProductEligibilityRequest": {
            "fields": {}
          },
          "EvaluateProductEligibilityResponse": {
            "fields": {
              "productEligibilities": {
                "type": ".squareup.bitty.EvaluateProductEligibilityResponse.ProductEligibility",
                "id": 1,
                "rule": "repeated"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            },
            "nested": {
              "ProductEligibility": {
                "fields": {
                  "product": {
                    "type": ".squareup.bitty.EvaluateProductEligibilityResponse.Product",
                    "id": 1,
                    "rule": "optional"
                  },
                  "eligibilityStatus": {
                    "type": ".squareup.bitty.EvaluateProductEligibilityResponse.EligibilityStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ineligibilityReasons": {
                    "type": ".squareup.bitty.EvaluateProductEligibilityResponse.IneligibilityReason",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "Product": {
                "values": {
                  "DO_NOT_USE_PRODUCT": 0,
                  "WALLET": 1,
                  "CONVERSIONS": 2
                }
              },
              "EligibilityStatus": {
                "values": {
                  "DO_NOT_USE_ELIGIBILITY_STATUS": 0,
                  "ELIGIBLE": 1,
                  "INELIGIBLE": 2,
                  "CAN_ONBOARD": 3
                }
              },
              "IneligibilityReason": {
                "values": {
                  "DO_NOT_USE_INELIGIBILITY_REASON": 0,
                  "TWO_FACTOR_NOT_ENABLED": 1,
                  "KYB_NOT_PASSED": 2,
                  "MAIN_UNIT_IN_NY_STATE": 3,
                  "UNSUPPORTED_COUNTRY": 4,
                  "FROZEN_UNITS": 5,
                  "FAILED_RISK_CHECK": 6,
                  "NO_BITCOIN_ACCOUNT": 7,
                  "PAYMENT_DEACTIVATED_UNITS": 8,
                  "FEATURE_FLAG_DISABLED": 9,
                  "UNIT_IN_NY_STATE": 10,
                  "UNIT_DEACTIVATED": 11,
                  "UNHANDLED_VIOLATION": 12,
                  "NOT_PAYMENT_ACTIVATED": 13,
                  "INELIGIBLE_BITCOIN_ACCOUNT_STATUS": 14,
                  "MAIN_UNIT_IN_US_TERRITORY": 15,
                  "UNIT_IN_US_TERRITORY": 16
                }
              }
            }
          },
          "ListConversionsReportRequest": {
            "fields": {
              "exchangeToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "ListConversionsReportResponse": {
            "fields": {
              "unitContributions": {
                "type": ".squareup.bitty.ConversionUnitContribution",
                "id": 1,
                "rule": "repeated"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "BittyService": {
            "methods": {
              "CreateWithdrawal": {
                "requestType": ".squareup.bitty.CreateWithdrawalRequest",
                "responseType": ".squareup.bitty.CreateWithdrawalResponse"
              },
              "CreateBitcoinAccount": {
                "requestType": ".squareup.bitty.CreateBitcoinAccountRequest",
                "responseType": ".squareup.bitty.CreateBitcoinAccountResponse"
              },
              "RetrieveBitcoinAccount": {
                "requestType": ".squareup.bitty.RetrieveBitcoinAccountRequest",
                "responseType": ".squareup.bitty.RetrieveBitcoinAccountResponse"
              },
              "UpdateBitcoinAccount": {
                "requestType": ".squareup.bitty.UpdateBitcoinAccountRequest",
                "responseType": ".squareup.bitty.UpdateBitcoinAccountResponse"
              },
              "EvaluateKybStatus": {
                "requestType": ".squareup.bitty.EvaluateKybStatusRequest",
                "responseType": ".squareup.bitty.EvaluateKybStatusResponse"
              },
              "GetBitcoinActivityDetail": {
                "requestType": ".squareup.bitty.GetBitcoinActivityDetailRequest",
                "responseType": ".squareup.bitty.GetBitcoinActivityDetailResponse"
              },
              "CreateWaitlistEntry": {
                "requestType": ".squareup.bitty.CreateWaitlistEntryRequest",
                "responseType": ".squareup.bitty.CreateWaitlistEntryResponse"
              },
              "GetContent": {
                "requestType": ".squareup.bitty.GetContentRequest",
                "responseType": ".squareup.bitty.GetContentResponse"
              },
              "GetBitcoinActivities": {
                "requestType": ".squareup.bitty.GetBitcoinActivitiesRequest",
                "responseType": ".squareup.bitty.GetBitcoinActivitiesResponse"
              },
              "ExecuteWithdrawal": {
                "requestType": ".squareup.bitty.ExecuteWithdrawalRequest",
                "responseType": ".squareup.bitty.ExecuteWithdrawalResponse"
              },
              "SecureExecuteWithdrawal": {
                "requestType": ".squareup.bitty.ExecuteWithdrawalRequest",
                "responseType": ".squareup.bitty.ExecuteWithdrawalResponse"
              },
              "CreateOnDemandKybSession": {
                "requestType": ".squareup.bitty.CreateOnDemandKybSessionRequest",
                "responseType": ".squareup.bitty.CreateOnDemandKybSessionResponse"
              },
              "GetExchangeQuote": {
                "requestType": ".squareup.bitty.GetExchangeQuoteRequest",
                "responseType": ".squareup.bitty.GetExchangeQuoteResponse"
              },
              "SecureExecuteManualExchange": {
                "requestType": ".squareup.bitty.ExecuteManualExchangeRequest",
                "responseType": ".squareup.bitty.ExecuteManualExchangeResponse"
              },
              "GetSourceTargetBalances": {
                "requestType": ".squareup.bitty.GetSourceTargetBalancesRequest",
                "responseType": ".squareup.bitty.GetSourceTargetBalancesResponse"
              },
              "CheckBitcoinPaymentsEnabled": {
                "requestType": ".squareup.bitty.CheckBitcoinPaymentsEnabledRequest",
                "responseType": ".squareup.bitty.CheckBitcoinPaymentsEnabledResponse"
              },
              "ListPromotionalRewards": {
                "requestType": ".squareup.bitty.ListPromotionalRewardsRequest",
                "responseType": ".squareup.bitty.ListPromotionalRewardsResponse"
              },
              "GetOrCreateW9Info": {
                "requestType": ".squareup.bitty.GetOrCreateW9InfoRequest",
                "responseType": ".squareup.bitty.GetOrCreateW9InfoResponse"
              },
              "CompleteW9Info": {
                "requestType": ".squareup.bitty.CompleteW9InfoRequest",
                "responseType": ".squareup.bitty.CompleteW9InfoResponse"
              },
              "EvaluateProductEligibility": {
                "requestType": ".squareup.bitty.EvaluateProductEligibilityRequest",
                "responseType": ".squareup.bitty.EvaluateProductEligibilityResponse"
              },
              "ListConversionsReport": {
                "requestType": ".squareup.bitty.ListConversionsReportRequest",
                "responseType": ".squareup.bitty.ListConversionsReportResponse"
              },
              "GetDepositAddress": {
                "requestType": ".squareup.bitty.GetDepositAddressRequest",
                "responseType": ".squareup.bitty.GetDepositAddressResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bitty?.nested?.CreateWithdrawalRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.CreateWithdrawalResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.CreateBitcoinAccountRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.CreateBitcoinAccountResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.RetrieveBitcoinAccountRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.RetrieveBitcoinAccountResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.UpdateBitcoinAccountRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.UpdateBitcoinAccountResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.EvaluateKybStatusRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.EvaluateKybStatusResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.GetBitcoinActivitiesRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.GetBitcoinActivitiesResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.GetBitcoinActivityDetailRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.GetBitcoinActivityDetailResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.CreateWaitlistEntryRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.CreateWaitlistEntryResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.GetContentRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.GetContentResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.ExecuteWithdrawalRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.ExecuteWithdrawalResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.CreateOnDemandKybSessionRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.CreateOnDemandKybSessionResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.GetExchangeQuoteRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.GetExchangeQuoteResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.ExecuteManualExchangeRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.ExecuteManualExchangeResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.GetSourceTargetBalancesRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.GetSourceTargetBalancesResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.CheckBitcoinPaymentsEnabledRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.CheckBitcoinPaymentsEnabledResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.ListPromotionalRewardsRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.ListPromotionalRewardsResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.GetDepositAddressRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.GetDepositAddressResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.EvaluateProductEligibilityRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.EvaluateProductEligibilityResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.EvaluateProductEligibilityResponse?.nested?.ProductEligibility && !$root.nested?.squareup?.nested?.bitty?.nested?.EvaluateProductEligibilityResponse?.nested?.Product && !$root.nested?.squareup?.nested?.bitty?.nested?.EvaluateProductEligibilityResponse?.nested?.EligibilityStatus && !$root.nested?.squareup?.nested?.bitty?.nested?.EvaluateProductEligibilityResponse?.nested?.IneligibilityReason && !$root.nested?.squareup?.nested?.bitty?.nested?.ListConversionsReportRequest && !$root.nested?.squareup?.nested?.bitty?.nested?.ListConversionsReportResponse && !$root.nested?.squareup?.nested?.bitty?.nested?.BittyService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateWithdrawalRequest @ squareup/bitty/service.proto at 21:1
 */
export const CreateWithdrawalRequest = $root.lookupType('squareup.bitty.CreateWithdrawalRequest');
fixType(CreateWithdrawalRequest);
Builder.createAndAttachToType(CreateWithdrawalRequest);
/**
 * SOURCE CreateWithdrawalResponse @ squareup/bitty/service.proto at 35:1
 */
export const CreateWithdrawalResponse = $root.lookupType('squareup.bitty.CreateWithdrawalResponse');
fixType(CreateWithdrawalResponse);
Builder.createAndAttachToType(CreateWithdrawalResponse);
/**
 * SOURCE CreateBitcoinAccountRequest @ squareup/bitty/service.proto at 46:1
 */
export const CreateBitcoinAccountRequest = $root.lookupType('squareup.bitty.CreateBitcoinAccountRequest');
fixType(CreateBitcoinAccountRequest);
Builder.createAndAttachToType(CreateBitcoinAccountRequest);
/**
 * SOURCE CreateBitcoinAccountResponse @ squareup/bitty/service.proto at 53:1
 */
export const CreateBitcoinAccountResponse = $root.lookupType('squareup.bitty.CreateBitcoinAccountResponse');
fixType(CreateBitcoinAccountResponse);
Builder.createAndAttachToType(CreateBitcoinAccountResponse);
/**
 * SOURCE RetrieveBitcoinAccountRequest @ squareup/bitty/service.proto at 60:1
 */
export const RetrieveBitcoinAccountRequest = $root.lookupType('squareup.bitty.RetrieveBitcoinAccountRequest');
fixType(RetrieveBitcoinAccountRequest);
Builder.createAndAttachToType(RetrieveBitcoinAccountRequest);
/**
 * SOURCE RetrieveBitcoinAccountResponse @ squareup/bitty/service.proto at 65:1
 */
export const RetrieveBitcoinAccountResponse = $root.lookupType('squareup.bitty.RetrieveBitcoinAccountResponse');
fixType(RetrieveBitcoinAccountResponse);
Builder.createAndAttachToType(RetrieveBitcoinAccountResponse);
/**
 * SOURCE UpdateBitcoinAccountRequest @ squareup/bitty/service.proto at 84:1
 */
export const UpdateBitcoinAccountRequest = $root.lookupType('squareup.bitty.UpdateBitcoinAccountRequest');
fixType(UpdateBitcoinAccountRequest);
Builder.createAndAttachToType(UpdateBitcoinAccountRequest);
/**
 * SOURCE UpdateBitcoinAccountResponse @ squareup/bitty/service.proto at 89:1
 */
export const UpdateBitcoinAccountResponse = $root.lookupType('squareup.bitty.UpdateBitcoinAccountResponse');
fixType(UpdateBitcoinAccountResponse);
Builder.createAndAttachToType(UpdateBitcoinAccountResponse);
/**
 * SOURCE EvaluateKybStatusRequest @ squareup/bitty/service.proto at 96:1
 */
export const EvaluateKybStatusRequest = $root.lookupType('squareup.bitty.EvaluateKybStatusRequest');
fixType(EvaluateKybStatusRequest);
Builder.createAndAttachToType(EvaluateKybStatusRequest);
/**
 * SOURCE EvaluateKybStatusResponse @ squareup/bitty/service.proto at 106:1
 */
export const EvaluateKybStatusResponse = $root.lookupType('squareup.bitty.EvaluateKybStatusResponse');
fixType(EvaluateKybStatusResponse);
Builder.createAndAttachToType(EvaluateKybStatusResponse);
/**
 * SOURCE GetBitcoinActivitiesRequest @ squareup/bitty/service.proto at 119:1
 */
export const GetBitcoinActivitiesRequest = $root.lookupType('squareup.bitty.GetBitcoinActivitiesRequest');
fixType(GetBitcoinActivitiesRequest);
Builder.createAndAttachToType(GetBitcoinActivitiesRequest);
/**
 * SOURCE GetBitcoinActivitiesResponse @ squareup/bitty/service.proto at 145:1
 */
export const GetBitcoinActivitiesResponse = $root.lookupType('squareup.bitty.GetBitcoinActivitiesResponse');
fixType(GetBitcoinActivitiesResponse);
Builder.createAndAttachToType(GetBitcoinActivitiesResponse);
/**
 * SOURCE GetBitcoinActivityDetailRequest @ squareup/bitty/service.proto at 156:1
 */
export const GetBitcoinActivityDetailRequest = $root.lookupType('squareup.bitty.GetBitcoinActivityDetailRequest');
fixType(GetBitcoinActivityDetailRequest);
Builder.createAndAttachToType(GetBitcoinActivityDetailRequest);
/**
 * SOURCE GetBitcoinActivityDetailResponse @ squareup/bitty/service.proto at 166:1
 */
export const GetBitcoinActivityDetailResponse = $root.lookupType('squareup.bitty.GetBitcoinActivityDetailResponse');
fixType(GetBitcoinActivityDetailResponse);
Builder.createAndAttachToType(GetBitcoinActivityDetailResponse);
/**
 * SOURCE CreateWaitlistEntryRequest @ squareup/bitty/service.proto at 176:1
 */
export const CreateWaitlistEntryRequest = $root.lookupType('squareup.bitty.CreateWaitlistEntryRequest');
fixType(CreateWaitlistEntryRequest);
Builder.createAndAttachToType(CreateWaitlistEntryRequest);
/**
 * SOURCE CreateWaitlistEntryResponse @ squareup/bitty/service.proto at 179:1
 */
export const CreateWaitlistEntryResponse = $root.lookupType('squareup.bitty.CreateWaitlistEntryResponse');
fixType(CreateWaitlistEntryResponse);
Builder.createAndAttachToType(CreateWaitlistEntryResponse);
/**
 * SOURCE GetContentRequest @ squareup/bitty/service.proto at 184:1
 */
export const GetContentRequest = $root.lookupType('squareup.bitty.GetContentRequest');
fixType(GetContentRequest);
Builder.createAndAttachToType(GetContentRequest);
/**
 * SOURCE GetContentResponse @ squareup/bitty/service.proto at 188:1
 */
export const GetContentResponse = $root.lookupType('squareup.bitty.GetContentResponse');
fixType(GetContentResponse);
Builder.createAndAttachToType(GetContentResponse);
/**
 * Request to progress a withdrawal through the hurdle-based flow
 *
 * SOURCE ExecuteWithdrawalRequest @ squareup/bitty/service.proto at 195:1
 */
export const ExecuteWithdrawalRequest = $root.lookupType('squareup.bitty.ExecuteWithdrawalRequest');
fixType(ExecuteWithdrawalRequest);
Builder.createAndAttachToType(ExecuteWithdrawalRequest);
/**
 * Response containing next steps in the withdrawal flow
 *
 * SOURCE ExecuteWithdrawalResponse @ squareup/bitty/service.proto at 204:1
 */
export const ExecuteWithdrawalResponse = $root.lookupType('squareup.bitty.ExecuteWithdrawalResponse');
fixType(ExecuteWithdrawalResponse);
Builder.createAndAttachToType(ExecuteWithdrawalResponse);
/**
 * SOURCE CreateOnDemandKybSessionRequest @ squareup/bitty/service.proto at 215:1
 */
export const CreateOnDemandKybSessionRequest = $root.lookupType('squareup.bitty.CreateOnDemandKybSessionRequest');
fixType(CreateOnDemandKybSessionRequest);
Builder.createAndAttachToType(CreateOnDemandKybSessionRequest);
/**
 * SOURCE CreateOnDemandKybSessionResponse @ squareup/bitty/service.proto at 219:1
 */
export const CreateOnDemandKybSessionResponse = $root.lookupType('squareup.bitty.CreateOnDemandKybSessionResponse');
fixType(CreateOnDemandKybSessionResponse);
Builder.createAndAttachToType(CreateOnDemandKybSessionResponse);
/**
 * SOURCE GetExchangeQuoteRequest @ squareup/bitty/service.proto at 228:1
 */
export const GetExchangeQuoteRequest = $root.lookupType('squareup.bitty.GetExchangeQuoteRequest');
fixType(GetExchangeQuoteRequest);
Builder.createAndAttachToType(GetExchangeQuoteRequest);
/**
 * SOURCE GetExchangeQuoteResponse @ squareup/bitty/service.proto at 235:1
 */
export const GetExchangeQuoteResponse = $root.lookupType('squareup.bitty.GetExchangeQuoteResponse');
fixType(GetExchangeQuoteResponse);
Builder.createAndAttachToType(GetExchangeQuoteResponse);
/**
 * SOURCE ExecuteManualExchangeRequest @ squareup/bitty/service.proto at 242:1
 */
export const ExecuteManualExchangeRequest = $root.lookupType('squareup.bitty.ExecuteManualExchangeRequest');
fixType(ExecuteManualExchangeRequest);
Builder.createAndAttachToType(ExecuteManualExchangeRequest);
/**
 * SOURCE ExecuteManualExchangeResponse @ squareup/bitty/service.proto at 253:1
 */
export const ExecuteManualExchangeResponse = $root.lookupType('squareup.bitty.ExecuteManualExchangeResponse');
fixType(ExecuteManualExchangeResponse);
Builder.createAndAttachToType(ExecuteManualExchangeResponse);
/**
 * SOURCE GetSourceTargetBalancesRequest @ squareup/bitty/service.proto at 258:1
 */
export const GetSourceTargetBalancesRequest = $root.lookupType('squareup.bitty.GetSourceTargetBalancesRequest');
fixType(GetSourceTargetBalancesRequest);
Builder.createAndAttachToType(GetSourceTargetBalancesRequest);
/**
 * SOURCE GetSourceTargetBalancesResponse @ squareup/bitty/service.proto at 262:1
 */
export const GetSourceTargetBalancesResponse = $root.lookupType('squareup.bitty.GetSourceTargetBalancesResponse');
fixType(GetSourceTargetBalancesResponse);
Builder.createAndAttachToType(GetSourceTargetBalancesResponse);
/**
 * SOURCE CheckBitcoinPaymentsEnabledRequest @ squareup/bitty/service.proto at 268:1
 */
export const CheckBitcoinPaymentsEnabledRequest = $root.lookupType('squareup.bitty.CheckBitcoinPaymentsEnabledRequest');
fixType(CheckBitcoinPaymentsEnabledRequest);
Builder.createAndAttachToType(CheckBitcoinPaymentsEnabledRequest);
/**
 * SOURCE CheckBitcoinPaymentsEnabledResponse @ squareup/bitty/service.proto at 275:1
 */
export const CheckBitcoinPaymentsEnabledResponse = $root.lookupType('squareup.bitty.CheckBitcoinPaymentsEnabledResponse');
fixType(CheckBitcoinPaymentsEnabledResponse);
Builder.createAndAttachToType(CheckBitcoinPaymentsEnabledResponse);
/**
 * SOURCE ListPromotionalRewardsRequest @ squareup/bitty/service.proto at 282:1
 */
export const ListPromotionalRewardsRequest = $root.lookupType('squareup.bitty.ListPromotionalRewardsRequest');
fixType(ListPromotionalRewardsRequest);
Builder.createAndAttachToType(ListPromotionalRewardsRequest);
/**
 * SOURCE ListPromotionalRewardsResponse @ squareup/bitty/service.proto at 288:1
 */
export const ListPromotionalRewardsResponse = $root.lookupType('squareup.bitty.ListPromotionalRewardsResponse');
fixType(ListPromotionalRewardsResponse);
Builder.createAndAttachToType(ListPromotionalRewardsResponse);
/**
 * SOURCE GetDepositAddressRequest @ squareup/bitty/service.proto at 295:1
 */
export const GetDepositAddressRequest = $root.lookupType('squareup.bitty.GetDepositAddressRequest');
fixType(GetDepositAddressRequest);
Builder.createAndAttachToType(GetDepositAddressRequest);
/**
 * SOURCE GetDepositAddressResponse @ squareup/bitty/service.proto at 299:1
 */
export const GetDepositAddressResponse = $root.lookupType('squareup.bitty.GetDepositAddressResponse');
fixType(GetDepositAddressResponse);
Builder.createAndAttachToType(GetDepositAddressResponse);
/**
 * SOURCE EvaluateProductEligibilityRequest @ squareup/bitty/service.proto at 306:1
 */
export const EvaluateProductEligibilityRequest = $root.lookupType('squareup.bitty.EvaluateProductEligibilityRequest');
fixType(EvaluateProductEligibilityRequest);
Builder.createAndAttachToType(EvaluateProductEligibilityRequest);
/**
 * SOURCE EvaluateProductEligibilityResponse @ squareup/bitty/service.proto at 310:1
 */
export const EvaluateProductEligibilityResponse = $root.lookupType('squareup.bitty.EvaluateProductEligibilityResponse');
fixType(EvaluateProductEligibilityResponse);
Builder.createAndAttachToType(EvaluateProductEligibilityResponse);
/**
 * SOURCE ProductEligibility @ squareup/bitty/service.proto at 316:3
 */
EvaluateProductEligibilityResponse.ProductEligibility = $root.lookupType('squareup.bitty.EvaluateProductEligibilityResponse.ProductEligibility');
fixType(EvaluateProductEligibilityResponse.ProductEligibility);
Builder.createAndAttachToType(EvaluateProductEligibilityResponse.ProductEligibility);
/**
 * SOURCE Product @ squareup/bitty/service.proto at 326:3
 */
EvaluateProductEligibilityResponse.Product = $root.lookupEnum('squareup.bitty.EvaluateProductEligibilityResponse.Product').values;
/**
 * SOURCE EligibilityStatus @ squareup/bitty/service.proto at 335:3
 */
EvaluateProductEligibilityResponse.EligibilityStatus = $root.lookupEnum('squareup.bitty.EvaluateProductEligibilityResponse.EligibilityStatus').values;
/**
 * SOURCE IneligibilityReason @ squareup/bitty/service.proto at 351:3
 */
EvaluateProductEligibilityResponse.IneligibilityReason = $root.lookupEnum('squareup.bitty.EvaluateProductEligibilityResponse.IneligibilityReason').values;
/**
 * SOURCE ListConversionsReportRequest @ squareup/bitty/service.proto at 373:1
 */
export const ListConversionsReportRequest = $root.lookupType('squareup.bitty.ListConversionsReportRequest');
fixType(ListConversionsReportRequest);
Builder.createAndAttachToType(ListConversionsReportRequest);
/**
 * SOURCE ListConversionsReportResponse @ squareup/bitty/service.proto at 377:1
 */
export const ListConversionsReportResponse = $root.lookupType('squareup.bitty.ListConversionsReportResponse');
fixType(ListConversionsReportResponse);
Builder.createAndAttachToType(ListConversionsReportResponse);
/**
 * SOURCE BittyService @ squareup/bitty/service.proto at 382:1
 */
export const BittyService = $root.lookupService('squareup.bitty.BittyService');